const accessStatus = {
  employee: 'ENTRADA PERMITIDA',
  employee1: 'ENTRADA BLOQUEADA',
  company: 'LIBERADO',
  company1: 'NO LIBERADO'
};

export default accessStatus;
